<template>
    <div>
        <!-- Title -->
        <!-- <div class="title">
            <h2 class="text-center mb-4" v-if="!isLoading && panel && panel.length === 1">
                We Recommend {{ panel[0].panel_configuration.display_name }}
            </h2>
            <h2 class="text-center mb-4" v-else>
                Professionals We Recommend
            </h2>
        </div> -->
        <!-- / Title -->

        <!-- Is Loading -->
        <div v-if="isLoading" class="text-center">
            <spinner></spinner>
        </div>
        <!-- / Is Loading -->

        <!-- No panel -->
        <div v-if="!isLoading && !panel" class="text-center">
            <p>Nothing to show here.</p>
        </div>
        <!-- / No panel -->

        <!-- Single Panel Provider View -->
        <div v-if="!isLoading && panel && panel.length === 1" class="position-relative bg-white rounded-xxl-4 zindex-5">
            <div class="container pt-4 pb-5 mb-md-4">
                <div class="row">
                    <div class="position-relative pe-lg-5 mb-5 mb-lg-0 col-lg-7 col-12" style="z-index: 1025;">
                        <div class="d-flex justify-content-between mb-2">
                        </div>
                        <ul class="list-unstyled fs-sm mb-4">
                            <li v-if="panel[0].panel_configuration.location" class="d-flex align-items-center mb-2">
                                <i class="fi-map-pin text-muted me-2"></i>
                                <span>{{ panel[0].panel_configuration.location }}</span>
                            </li>
                            <li v-if="panel[0].panel_configuration.pricing_note" class="d-flex align-items-center mb-2">
                                <i class="fi-cash fs-base text-muted me-2"></i>
                                <span>{{ panel[0].panel_configuration.pricing_note }}</span>
                            </li>
                        </ul>
                        <hr class="mb-4">
                        <h3 class="h6">A Bit About Us</h3>
                        <p v-html="panel[0].panel_configuration.about_us"></p>
                        <h3 class="h6 pt-4">Meet Some Of Our Professionals</h3>
                        <div class="row">
                            <div class="col-lg-6" v-for="userRole in panel[0].panel_configuration.user_roles" :key="`panel-lawyer-${userRole.id}`">
                                <div class="mb-3">
                                    <panel-lawyer-card-and-bio :user-role="userRole"></panel-lawyer-card-and-bio>
                                </div>
                            </div>
                        </div>
                        <hr class="my-4">
                        <panel-start-conversation-button-and-modal-unauthenticated
                            v-if="!user"
                            :panel-configuration="panel[0].panel_configuration"
                            :referral-page-id="referralPageId"
                            :advisor-company-id="panel[0].advisor_company_id"
                            :secondary="true">
                        </panel-start-conversation-button-and-modal-unauthenticated>

                        <panel-start-conversation-button-and-modal
                            v-if="user" type="secondary"
                            :panel-configuration="panel[0].panel_configuration"
                            :referral-page-id="referralPageId"
                            :advisor-company-id="panel[0].advisor_company_id">
                        </panel-start-conversation-button-and-modal>
                    </div>
                    <aside class="col-lg-5 col-12" style="margin-top: -6rem;">
                        <div class="sticky-top" style="padding-top: 6rem;">
                            <div class="shadow-sm mb-3 mb-lg-0 card">
                                <div class="card-body">
                                    <h2 class="h3 mb-4">Pricing Estimates</h2>

                                    <!-- Fixed Prices -->
                                    <div v-if="fixedPrices && fixedPrices.length">
                                        <h6>Fixed Prices</h6>
                                        <table class="table table-responsive">
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>Guideline Price (Ex VAT)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(fixedPrice, i) in fixedPrices" :key="`fixed-price-${i}`">
                                                    <td>{{ fixedPrice.service }}</td>
                                                    <td>{{ formatCostInPence2dp(fixedPrice.lower_price) }} <span v-if="fixedPrice.upper_price"> - {{ formatCostInPence2dp(fixedPrice.upper_price) }}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Hourly Prices -->
                                    <div v-if="hourlyPrices && hourlyPrices.length" :class="{ 'mt-5': (hourlyPrices.length && fixedPrices.length) }">
                                        <h6>Hourly Prices</h6>
                                        <table class="table table-responsive">
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>Guideline Price (Ex VAT)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(hourlyPrice, i) in hourlyPrices" :key="`hourly-price-${i}`">
                                                    <td>{{ hourlyPrice.service }}</td>
                                                    <td>{{ formatCostInPence2dp(hourlyPrice.lower_price) }} <span v-if="hourlyPrice.upper_price"> - {{ formatCostInPence2dp(hourlyPrice.upper_price) }}</span> / hour</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
        <!-- / Single Panel Provider View -->

        <!-- Multiple Panel Providers View -->
        <div v-if="!isLoading && panel && panel.length > 1">
            <div
                class="row"
                :class="{ 'justify-content-center': panel && panel.length === 2 }"
            >
                <div
                    class="col-12 mb-3"
                    :class="panel && panel.length === 2 ? 'col-md-5' : 'col-md-4'"
                    v-for="(panelLink, i) in panel"
                    :key="`panel-link-${i}`"
                >
                    <div class="card card-body bg-secondary panel-lawyer-card mb-3">
                        <div class="top">
                            <router-link :to="`/landing/${panelLink.id}`">
                                <panel-configuration-logo :panel-configuration-id="panelLink.panel_configuration_id"></panel-configuration-logo>
                            </router-link>

                            <div class="description">
                                <p>{{ panelLink.panel_configuration.description }}</p>
                            </div>
                        </div>
                        <div class="bottom"></div>

                        <panel-start-conversation-button-and-modal-unauthenticated
                            :panel-configuration="panelLink.panel_configuration"
                            :referral-page-id="referralPageId"
                            :advisor-company-id="panelLink.advisor_company_id">
                        </panel-start-conversation-button-and-modal-unauthenticated>

                        <div class="row">
                            <div class="col-lg-6 mt-3">
                                <panel-pricing-button-and-modal :panel-configuration="panelLink.panel_configuration">
                                </panel-pricing-button-and-modal>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <router-link class="btn btn-dark btn-block w-100" :to="`/referral/${referralPageId}/${panelLink.id}`">
                                    About Us
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- / Multiple Panel Providers View -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from '../../components/Spinner.vue'
import axios from 'axios';
import PanelConfigurationLogo from '../../components/PanelConfiguration/PanelConfigurationLogo.vue'
import PanelPricingButtonAndModal from '../../components/PanelConfiguration/PanelPricingButtonAndModal.vue';
import PanelStartConversationButtonAndModalUnauthenticated from '../../components/PanelConfiguration/PanelStartConversationButtonAndModalUnauthenticated.vue';
import PanelStartConversationButtonAndModal from '../../components/PanelConfiguration/PanelStartConversationButtonAndModal.vue';
import PanelLawyerCardAndBio from '../../components/PanelConfiguration/PanelLawyerCardAndBio.vue';
import Display from '../../mixins/Display';
import _ from 'lodash';

export default {
    props: ['referralPageId', 'referralPageSlug'],

    data() {
        return {
            isLoading: false,
            panel: null,
        }
    },

    components: { 
        Spinner, 
        PanelConfigurationLogo, 
        PanelPricingButtonAndModal, 
        PanelStartConversationButtonAndModalUnauthenticated,
        PanelStartConversationButtonAndModal,
        PanelLawyerCardAndBio
    },

    mixins: [Display],

    created() {
        this.fetch();
    },

    computed: {
        ...mapGetters('auth', {
            user: 'user'
        }),

        fixedPrices() {
            if (!this.panel || !this.panel[0]) {
                return [];
            }
            return _.filter(this.panel[0].panel_configuration.panel_configuration_pricings, { price_type: 'fixed' });
        },

        hourlyPrices() {
            if (!this.panel || !this.panel[0]) {
                return [];
            }
            return _.filter(this.panel[0].panel_configuration.panel_configuration_pricings, { price_type: 'hourly' });
        }
    },

    methods: {
        fetch() {
            let vm = this;
            vm.isLoading = true;
            axios.get(window.API_BASE + '/referral-pages/' + vm.referralPageId + '/panel')
                .then(function (response) {
                    vm.panel = response.data;
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    vm.isLoading = false;
                });
        }
    }
}
</script>

<style scoped lang="scss">
.panel-lawyer-card {
    text-align: center;
    height: 100%;

    display: flex;
    flex-direction: column;

    .top {
        flex-grow: 1;
    }

    .bottom {
        flex-shrink: 1;
    }

    .description {
        font-weight: 500;
        margin-top: 30px;
        margin-bottom: 15px;
    }
}
</style>